import React from 'react';
import { useTranslation } from '../../i18n/i18n';
import { DownloadIcon } from '../icons/Icons';
import './DownloadButton.scss';

const DownloadButton = ({
  onClick,
  disabled,
  loading,
  progress = 0,
}: {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  /** Readings received so far, shown while loading. */
  progress?: number;
}) => {
  const { t } = useTranslation('common');
  return (
    <button
      type="button"
      className="DownloadButton"
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
    >
      <DownloadIcon />
      {loading ? (progress ? t('downloadingCsvCount', { count: progress }) : t('downloadingCsv')) : t('downloadCsv')}
    </button>
  );
};

export default DownloadButton;
